const fleetStatus = (instance) => {
    return [
      { name: instance.$t('fleetAvailability.status.draft'), color: '#67718B' },
      { name: instance.$t('fleetAvailability.status.scheduled'), color: '#8F49DE' },
      { name: instance.$t('fleetAvailability.status.started'), color: '#1C74DA' },
      { name: instance.$t('fleetAvailability.status.delivered'), color: '#137C55' },
      // NOTE: Hidden for next enhancement
      // { name: instance.$t('fleetAvailability.status.problem'), color: '#F41D00' },
    ]
  }
  
  export default fleetStatus